import { z } from 'zod';
export const communicationsInternalReportDeliveryCapability = 'communications.internal-report-delivery.v1';
export const communicationsInternalReportDeliverySlot = 'reporting.internal-report-delivery';
export const communicationsInternalReportDeliveryProviderId = 'communications.server.internal-report-delivery';
export const communicationsInternalReportDeliveryRequestSchema = z.strictObject({
    sourceCapability: z.literal('reporting.schedule-runs.v1'),
    sourceRunId: z.string().uuid(),
    sourceScheduleId: z.string().uuid(),
    recipientMembershipIds: z.array(z.string().uuid()).min(1).max(50),
    subject: z.string().trim().min(1).max(240),
    body: z.string().trim().min(1).max(10_000),
    attachment: z.strictObject({
        fileName: z.string().trim().min(1).max(180),
        contentType: z.literal('text/csv; charset=utf-8'),
        content: z.string().min(1).max(5_242_880),
        sha256: z.string().regex(/^[a-f0-9]{64}$/),
        byteLength: z.number().int().positive().max(5_242_880),
    }),
    retentionDays: z.number().int().min(1).max(30),
}).superRefine((value, context) => {
    if (new Set(value.recipientMembershipIds).size !== value.recipientMembershipIds.length) {
        context.addIssue({
            code: 'custom', path: ['recipientMembershipIds'], message: 'Recipients cannot repeat.',
        });
    }
    if (new TextEncoder().encode(value.attachment.content).byteLength !== value.attachment.byteLength) {
        context.addIssue({
            code: 'custom', path: ['attachment', 'byteLength'],
            message: 'Attachment byte length must match UTF-8 content.',
        });
    }
});
export const communicationsInternalReportDeliveryResponseSchema = z.strictObject({
    state: z.literal('accepted'),
    capability: z.literal(communicationsInternalReportDeliveryCapability),
    queuedCount: z.number().int().nonnegative().max(50),
    suppressedCount: z.number().int().nonnegative().max(50),
    replayedCount: z.number().int().nonnegative().max(50),
    replayedQueuedCount: z.number().int().nonnegative().max(50),
    replayedSuppressedCount: z.number().int().nonnegative().max(50),
}).superRefine((value, context) => {
    const classifiedCount = value.queuedCount + value.suppressedCount + value.replayedCount;
    if (classifiedCount < 1 || classifiedCount > 50) {
        context.addIssue({ code: 'custom', message: 'Delivery acceptance must classify recipients.' });
    }
    if (value.replayedQueuedCount + value.replayedSuppressedCount !== value.replayedCount) {
        context.addIssue({
            code: 'custom', path: ['replayedCount'],
            message: 'Replay classification must reconcile to the replayed recipient count.',
        });
    }
});
//# sourceMappingURL=communications-internal-report-delivery.contract.js.map